// 默认交易所常量
export const SINA_SZ = "sz"; // 深交所相关常量
export const SINA_SH = "sh"; // 上交所相关常量
export const SINA_HK = "hk"; // 港交所相关常量
export const SINA_US = "gb_"; // 美交所相关常量
